import categoriesData from './shared/state';

export default {
  modules: {
    categoriesData,
  },
};
